import { Outlet } from "react-router-dom";
import TrackPageChanges from "../application/track-page-changes";
import { Fragment } from "react";
import { ClientApplication } from "@edgetier/client-components";

const Layout = () => {
    return (
        <Fragment>
            <TrackPageChanges />
            <ClientApplication>
                <Outlet />
            </ClientApplication>
        </Fragment>
    );
};

export default Layout;
